import React from 'react';
import NavBar from '../NavBar/NavBar';
import Footer from '../Footer/Footer'
import { Outlet } from 'react-router';


function WithNav(){

    return(
        <div className="WithNav">
        <NavBar/>
        <Outlet/>
        <Footer/>
        </div>
    )


}

export default WithNav;